

















import Vue from "vue";
export default Vue.extend({
  name: "erase-button",
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    tooltipText: {
      type: String,
      required: false,
      default: "Leegmaken",
    },
  },
  data() {
    return {};
  },
});
